













































































































































import { Component, Inject, Vue } from "vue-property-decorator";
import {
  IAffiliatesProvider,
  IAffiliatesProviderMethods
} from "@/models/providers/affiliates";

@Component({
  inheritAttrs: false,
  components: {
    "affiliates-provider": () =>
      import("@/components/app/global/affiliate/affiliatesProvider.vue")
  }
})
export default class AffiliatesTable extends Vue {
  // Inject

  @Inject({ from: "affiliatesProvider" })
  public readonly $affiliatesProvider!: () => IAffiliatesProvider;

  @Inject({ from: "affiliatesProviderMethods" })
  public readonly $affiliatesMethods!: IAffiliatesProviderMethods;

  // Computed

  public get $affiliatesData() {
    return this.$affiliatesProvider();
  }
}
